@if (control$$()) {
    <mat-form-field
        [ngClass]="classHeight$$()"
        [class.show-hint]="hint$$() || hintLabel$$()"
        [class.show-error]="control$$().invalid && errorShow$$()"
        [appearance]="appearance$$()"
        [color]="color$$()"
        [floatLabel]="floatLabel$$()"
        [hideRequiredMarker]="hideRequiredMarker$$()"
        [hintLabel]="hintLabel$$()"
        [subscriptSizing]="subscriptSizing$$()">

        @if (label$$()) {
            <mat-label>{{label$$()}}:</mat-label>
        }
        <textarea matNativeControl #inputField id="inputField"
            (keydown.esc)="emit_esc($event)"
            [attributes]="attributes$$()"
            [autofocus]="autofocus$$()"
            [cdkTextareaAutosize]="input_autosize$$()"
            [cdkAutosizeMinRows]="input_minRows$$()"
            [cdkAutosizeMaxRows]="input_maxRows$$()"
            [errorStateMatcher]="errorStateMatcher$$()"
            [formControl]="control$$()"
            [id]="id$$()"
            [placeholder]="placeholder$$()"
            [readonly]="readonly$$()"
            [required]="required$$()"
            [rows]="input_rows$$()"
            [tabindex]="tabIndex$$()"
        ></textarea>
        @if (!!hint$$()) {
            <mat-hint [align]="hintAlign$$()">{{hint$$()}}</mat-hint>
        }
        @if (control$$().invalid && errorShow$$()) {
            <mat-error>{{errorMessage_getFirst()}}</mat-error>
        }
    </mat-form-field>
}
